/* eslint-disable import/no-cycle */
/* eslint-disable no-underscore-dangle */
import _ from 'lodash';
import store from 'shared/redux/store';
import {
  registerAccount,
  getStepStatus,
  generateChannel,
  refreshApp,
  websocketConnect,
} from 'shared/redux/actions';
import { ACTION_TYPE } from 'shared/redux/actions/actionTypes';
import {
  PATH,
  STORAGE_KEY,
  expirationTime,
  WEBSOCKET_STATUS_NOT_CONNECTED,
  WEBSOCKET_STATUS_CLOSED,
} from 'shared/constants';
import {
  idleTimer,
  // clearIdleTimer,
} from 'shared/util/idleTimer';
import api from 'shared/services/api';
import {
  isMobile, browserName, isIOS, osName,
} from 'react-device-detect';
import * as serviceWorker from './serviceWorker';
import {
  trackUniqueUser, trackReturnVisitor, trackDropOff, trackPWAInstalled,
  trackDevice, trackBrowser, trackCountry,
} from './App.tracking';


export const refreshUser = () => {
  store.dispatch(refreshApp()).then(() => {
    store.dispatch({ type: ACTION_TYPE.REFRESH_USER });
    store.dispatch(generateChannel());
    window.location.replace(PATH.HOME);
  });
};

export const handleRegisterAccount = (tracking) => {
  const {
    userInfo,
    websocketStatus,
  } = store.getState().rootReducer;
  if (!(userInfo && userInfo._id)) {
    // if user is not exists then create a new account
    store.dispatch(registerAccount()).then((res) => {
      if (websocketStatus === WEBSOCKET_STATUS_NOT_CONNECTED || websocketStatus === WEBSOCKET_STATUS_CLOSED) {
        store.dispatch(websocketConnect());
      }
      /** track unique user */
      trackUniqueUser(tracking, res);
      /** */
    });
  } else {
    /** track return visitor */
    trackReturnVisitor(tracking, userInfo);
    /** */
  }
};

export const handleRefreshApp = (timer) => {
  const {
    userInfo,
    isStartStep,
    summary,
    websocketStatus,
  } = store.getState().rootReducer;
  /** refresh user function */
  const expirationDate = JSON.parse(localStorage.getItem(STORAGE_KEY.EXPIRATION_DATE));
  const rightNow = new Date().getTime();
  const expirationCondi = expirationDate && (rightNow - expirationDate) >= expirationTime;

  // refresh user after 15 mins unuse
  if (expirationCondi && isStartStep && !_.isEmpty(summary)) {
    refreshUser();
  } else {
    serviceWorker.register();
    // detect country origin/ browser/ device
    if ((userInfo && userInfo._id)
    && (websocketStatus === WEBSOCKET_STATUS_NOT_CONNECTED || websocketStatus === WEBSOCKET_STATUS_CLOSED)) {
    // connect to botkit
      store.dispatch(websocketConnect());
    }
  }

  // refresh user after 15 mins inactive
  idleTimer(timer, '.App', () => {
    // // we only clear the data if user has already answer at least one question!
    if (localStorage.getItem('state') && JSON.parse(localStorage.getItem('state')).isStartStep) {
      refreshUser();
    }
  }, expirationTime);

  // if the user is valid then get the status
  if (!expirationCondi && !_.isEmpty(summary)) {
    store.dispatch(getStepStatus());
  }
};

export const detectOnVisibilityChange = (tracking) => {
  let hidden;
  let visibilityChange;
  if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.mozHidden !== 'undefined') {
    hidden = 'mozHidden';
    visibilityChange = 'mozvisibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  } else {
    console.log('Page Visibility API not supported.');
  }

  function handleVisibilityChange() {
    if (document[hidden]) {
      const data = {
        stopStep: store.getState().rootReducer.inputComponent,
        stopThread: store.getState().rootReducer.currentThread,
      };
      trackDropOff(tracking, data);
    }
  }

  document.addEventListener(visibilityChange, handleVisibilityChange, false);
};

export const initialTracking = (tracking) => {
  setTimeout(() => {
    api.countryDetector().then((res) => {
      trackCountry(tracking, res);
    });

    // track device
    trackDevice(tracking, isMobile ? 'mobile' : 'desktop');
    // track browser
    trackBrowser(tracking, browserName);

    // if PWA on IOS device
    if (window.navigator.standalone === true) {
      trackPWAInstalled(tracking, osName);
      // console.log('display mode stand alone on IOS!');
    }

    // if PWA on others device
    if (window.matchMedia('(display-mode: standalone)').matches && !isIOS) {
      trackPWAInstalled(tracking, osName);
      // console.log('display mode stand alone except IOS!');
    }
    // window.onappinstalled = () => {
    //   trackPWAInstalled(tracking, userInfo);
    // console.log('Thank you for installing our app!');
    // };
  }, 3000);
};
